import { render, staticRenderFns } from "./mainDetails.vue?vue&type=template&id=48273d0f&scoped=true"
import script from "./mainDetails.vue?vue&type=script&lang=js"
export * from "./mainDetails.vue?vue&type=script&lang=js"
import style0 from "./mainDetails.vue?vue&type=style&index=0&id=48273d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48273d0f",
  null
  
)

export default component.exports